var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEntity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.31353C12 4.90897 12.1961 4.52803 12.5294 4.28529C14.8824 2.57157 18.1176 2.57157 20.4706 4.28529C20.8039 4.52803 21 4.90897 21 5.31353V17C21 18.1046 20.1046 19 19 19H14.2361C13.4785 19 12.786 19.428 12.4472 20.1056L12.0894 20.8211C12.0526 20.8948 11.9474 20.8948 11.9106 20.8211L11.5528 20.1056C11.214 19.428 10.5215 19 9.76393 19H5C3.89543 19 3 18.1046 3 17V5.31353C3 4.90897 3.19614 4.52803 3.52941 4.28529C5.88235 2.57157 9.11765 2.57157 11.4706 4.28529C11.8039 4.52803 12 4.90897 12 5.31353ZM12 5.31353V20",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntity);
export default __webpack_public_path__ + "static/media/entity.933996d949ccedd8b7ae70596a57264c.svg";
export { ForwardRef as ReactComponent };